export default __webpack_public_path__ + "static/media/alert-success-variation.a9193c7b.svg";